import { graphql } from 'gql'

export const UPDATE_AD_UNITS = graphql(`
  mutation updateAdUnits($input: UpdateAdUnitsInput!) {
    updateAdUnits(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`)
